module.exports = __webpack_public_path__ + "static/media/batuhan2.068e11d6.jpg";